export default __webpack_public_path__ + "static/media/ic-marker-maps.399ae098.svg";